import { useI18n } from '@/lib/i18n';
import './LanguageSwitch.css';

export function LanguageSwitch({ className = '' }: { className?: string }) {
  const { language, setLanguage, t } = useI18n();
  const next = language === 'tr' ? 'en' : 'tr';

  return (
    <button
      type="button"
      className={`language-switch ${className}`.trim()}
      onClick={() => setLanguage(next)}
      aria-label={language === 'tr' ? t('language.switchToEnglish') : t('language.switchToTurkish')}
      title={language === 'tr' ? t('language.switchToEnglish') : t('language.switchToTurkish')}
    >
      {next.toLocaleUpperCase('en-US')}
    </button>
  );
}

